// TOP LEVEL IMPORTS
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
// MUI
import windowSize from 'react-window-size';
// COMPONENTS

// MEDIA

// STYLED-COMPONENTS
// ==============================

// CONSTANTS & DESTRUCTURING
// ==============================

class ProtectedRoute extends React.Component {
  render() {
    const {
      currentUser,
      path,
      noNav,
      windowWidth,
      noFooter,
      theme,
      location,
      isAllowed,
      component: Component,
      layout: Layout,
      ...rest
    } = this.props;

    if (currentUser && currentUser.roles && currentUser.roles.includes('admin')) {
      return <Redirect to="/admin" />;
    }

    return (
      <Route
        {...rest}
        path={path}
        render={args => (
          <React.Fragment>
            {currentUser && currentUser._id ? (
              <Layout {...args} {...this.props}>
                <Component {...args} {...this.props} />
              </Layout>
            ) : (
              <Redirect to="/login" />
            )}
          </React.Fragment>
        )}
      />
    );
  }
}

export default windowSize(ProtectedRoute);



// WEBPACK FOOTER //
// ./src/components/route-components/ProtectedRoute/index.js